var map = {
	"./PaellaCoreLayouts.js": 1581,
	"./es.upv.paella.dualVideo.js": 7837,
	"./es.upv.paella.dualVideoDynamic.js": 7812,
	"./es.upv.paella.dualVideoPiP.js": 6868,
	"./es.upv.paella.nStreams.js": 6689,
	"./es.upv.paella.singleVideo.js": 135,
	"./es.upv.paella.singleVideoDynamic.js": 5202,
	"./es.upv.paella.tripleVideo.js": 1467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5546;